import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    userData: null,
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUserData(state, action) {
            state.userData = action.payload;
        },
        resetUser(state) {
            state.userData = null;
        },
    },
});

export const { setUserData, resetUser } = userSlice.actions;
export default userSlice.reducer;
